<div class="card">
  <div class="card-header">

    <form [formGroup]="formFilters">

      <div class="custom-toolbar-subdivision full-size">
        <div class="custom-toolbar-element custom-button-container-left split-size">
          <yo-commande-fournisseur-date-filter
            (onValueChange)="onDateFilterValueChange($event)"
            height="45px"
            [selectedDates]="selectedDates">
          </yo-commande-fournisseur-date-filter>

          <yo-tagbox
            [data]="unitesProduction"
            [selectedItems]="selectedUdpIdList()"
            placeholder="Unités de production..."
            title="Filtrer sur les unités de production"
            (onValueChange)="onUdpChange($event)">
          </yo-tagbox>

          <yo-multiselect
            [data]="fournisseurs"
            [key]="'fournisseurId'"
            [displayValue]="'fournisseurLibelle'"
            [selectedItems]="selectedFournisseurIdList()"
            [groupFn]="groupFournisseur"
            [width]="300"
            [maxDisplayedTags]="1"
            placeholder="Fournisseurs..."
            (onValueChange)="onFournisseursChange($event)">
          </yo-multiselect>

          <yo-lookup
            class="mg-r-20"
            [data]="statuts"
            [selectedItem]="selectedStatut?.id"
            [displayValue]="displayStatut"
            [width]="300"
            placeholder="Statuts de commande..."
            title="Filtrer sur les statuts de commande"
            (onValueChange)="onStatutChange($event)">
          </yo-lookup>
        </div>

        <div class="custom-button-container-right">
          <yo-button (onClick)="exportDatasToExcelFile()"
                     label="Exporter les données sous Excel" [theme]="ButtonThemeEnum.SECONDARY_INNER"></yo-button>
        </div>
      </div>

    </form>

  </div>

  <div class="card-body" style="overflow: auto;max-height:85vh; padding-bottom: 10vh">
    <div class="row">

      @if(amountItemsOrdersWithoutDetailsPerPeriodByProductionUnit) {
        <div class="col-md-6 mg-t-10">
          <div class="card">
            <div class="card-header">
              MONTANTS HEBDOMADAIRES DES ACHATS SANS DÉTAIL

              <span class="float-right">
                <a class="cursor" title="Export excel(csv)"
                   (click)="exportSimpleExcelCsv(amountItemsOrdersWithoutDetailsPerPeriodByProductionUnit, 'montants-hebdo-achats-sans-details')">
                  <i class="fa fa-file-excel fa-2x space yoni-color"></i>
                </a>
              </span>
            </div>

            <div class="card-boby">
              <dx-chart id="chart-montant-hebdo-achats-sans-details" (onPointClick)="displayDetailsAmountsItems($event)"
                        [dataSource]="amountItemsOrdersWithoutDetailsPerPeriodByProductionUnit"
                        [series]="seriesOptionsAmountItemsWithoutDetails">
                <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltipAmountItems"></dxo-tooltip>
                <dxo-export [enabled]="true"></dxo-export>
                <dxo-legend
                  verticalAlignment="bottom"
                  horizontalAlignment="center"
                  itemTextPosition="top">
                </dxo-legend>
              </dx-chart>
            </div>
          </div>
        </div>
      }

      @if(amountItemsOrdersWithDetailsPerPeriodByProductionUnit && seriesOptionsAmountItemsWithDetails.length) {
        <div class="col-md-6 mg-t-10">
          <div class="card">
            <div class="card-header">
              MONTANTS HEBDOMADAIRES DES ACHATS PAR FOURNISSEUR ({{ productionUnitSelectedForAmountItems }})

              <span class="float-right">
                <a class="cursor" title="Export excel(csv)"
                   (click)="exportSimpleExcelCsv(getFilteredWeeks(amountItemsOrdersWithDetailsPerPeriodByProductionUnitSelected), 'montants-hebdo-achats-par-fournisseur', true)"> <i
                  class="fa fa-file-excel fa-2x space yoni-color"></i></a>
              </span>
            </div>

            <div class="card-boby">
              <dx-chart id="chart-montant-hebdo-achats-avec-details"
                        [dataSource]="amountItemsOrdersWithDetailsPerPeriodByProductionUnitSelected"
                        [series]="seriesOptionsAmountItemsWithDetails">
                <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltipAmountItems"></dxo-tooltip>
                <dxo-export [enabled]="true"></dxo-export>
                <dxo-legend
                  verticalAlignment="bottom"
                  horizontalAlignment="center"
                  itemTextPosition="top">
                </dxo-legend>
              </dx-chart>
            </div>
          </div>
        </div>
      }

      @if(numberOrdersWithoutDetailsPerPeriodByProductionUnit) {
        <div class="col-md-6 mg-t-10">
          <div class="card">
            <div class="card-header">
              NOMBRE DE COMMANDES HEBDOMADAIRES

              <span class="float-right">
                <a class="cursor" title="Export excel(csv)"
                   (click)="exportSimpleExcelCsv(numberOrdersWithDetailsPerPeriodByProductionUnitSelected, 'nombre-hebdo-achats-sans-details')"> <i
                  class="fa fa-file-excel fa-2x space yoni-color"></i></a>
              </span>
            </div>

            <div class="card-boby">
              <dx-chart id="chart-nb-hebdo-achats-sans-details" (onPointClick)="displayDetailsNumberItems($event)"
                        [dataSource]="numberOrdersWithoutDetailsPerPeriodByProductionUnit"
                        [series]="seriesOptionsNumberItemsWithoutDetails">
                <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltip"></dxo-tooltip>
                <dxo-export [enabled]="true"></dxo-export>
                <dxo-legend
                  verticalAlignment="bottom"
                  horizontalAlignment="center"
                  itemTextPosition="top">
                </dxo-legend>
              </dx-chart>
            </div>
          </div>
        </div>
      }

      @if(numberOrdersWithDetailsPerPeriodByProductionUnitSelected && seriesOptionsNumberItemsWithDetails.length) {
        <div class="col-md-6 mg-t-10">
          <div class="card">
            <div class="card-header">
              NOMBRE DE COMMANDES HEBDOMADAIRES AVEC DÉTAIL FOURNISSEUR ({{ productionUnitSelectedForNumberItems }})

              <span class="float-right">
                <a class="cursor" title="Export excel(csv)"
                   (click)="exportSimpleExcelCsv(numberOrdersWithDetailsPerPeriodByProductionUnitSelected, 'nombre-commandes-hebdo-par-fournisseur')">
                  <i class="fa fa-file-excel fa-2x space yoni-color"></i>
                </a>
              </span>
            </div>

            <div class="card-boby">
              <dx-chart id="chart-nombre-hebdo-achats-avec-details"
                        [dataSource]="numberOrdersWithDetailsPerPeriodByProductionUnitSelected"
                        [series]="seriesOptionsNumberItemsWithDetails">
                <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltip"></dxo-tooltip>
                <dxo-export [enabled]="true"></dxo-export>
                <dxo-legend
                  verticalAlignment="bottom"
                  horizontalAlignment="center"
                  itemTextPosition="top">
                </dxo-legend>
              </dx-chart>
            </div>
          </div>
        </div>
      }

      @if(amountsItemsWeeklyPerFamilyAndPeriod && seriesOptionsAmountsItemsWeeklyPerFamilyAndPeriod.length) {
        <div class="col-md-6 mg-t-10">
          <div class="card">
            <div class="card-header">
              MONTANTS HEBDOMADAIRES DES ACHATS PAR FAMILLE DE DÉCLINAISON DENRÉE

              <span class="float-right">
                <a class="cursor" title="Export excel(csv)"
                   (click)="exportSimpleExcelCsv(amountsItemsWeeklyPerFamilyAndPeriod, 'montants-hebdo-par-famille-declinaison-denree')">
                  <i class="fa fa-file-excel fa-2x space yoni-color"></i>
                </a>
              </span>
            </div>

            <div class="card-boby">
              <dx-chart id="chart-amounts-items-weekly-per-family-and-period"
                        [dataSource]="amountsItemsWeeklyPerFamilyAndPeriod"
                        [series]="seriesOptionsAmountsItemsWeeklyPerFamilyAndPeriod">
                <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltipAmountStackBar"></dxo-tooltip>
                <dxo-export [enabled]="true"></dxo-export>
                <dxo-legend
                  verticalAlignment="bottom"
                  horizontalAlignment="center"
                  itemTextPosition="top">
                </dxo-legend>
              </dx-chart>
            </div>
          </div>
        </div>
      }

      @if (averageAmountItemsPerOrderAndPeriod) {
        <div class="col-md-6 mg-t-10">
          <div class="card">
            <div class="card-header">
              MONTANTS MOYEN DES ACHATS PAR COMMANDE

              <span class="float-right">
                <a class="cursor" title="Export excel(csv)"
                   (click)="exportSimpleExcelCsv(averageAmountItemsPerOrderAndPeriod, 'motant-moyen-achats-par-commande')">
                  <i class="fa fa-file-excel fa-2x space yoni-color"></i>
                </a>
              </span>
            </div>
            <div class="card-boby">
              <dx-chart
                id="average-amount-items-per-order"
                [dataSource]="averageAmountItemsPerOrderAndPeriod"
                [rotated]="true"
                [barGroupWidth]="8"
                title="Montant moyen des achats par commande">
                <dxo-common-series-settings argumentField="provider" type="stackedbar">
                </dxo-common-series-settings>
                <dxi-series valueField="amount" name="Montant" color="var(--action-color)"></dxi-series>
                <dxo-export [enabled]="true"></dxo-export>
                <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltipAmountItems"></dxo-tooltip>
                <dxi-value-axis>
                  <dxo-label [customizeText]="customizeLabelAmountItems"></dxo-label>
                </dxi-value-axis>
                <dxo-legend verticalAlignment="bottom" horizontalAlignment="center">
                  <dxo-margin [left]="50"></dxo-margin>
                </dxo-legend>
              </dx-chart>
            </div>
          </div>
        </div>
      }

      @if(numberItemsOrderedPerPeriod) {
        <div class="col-md-6 mg-t-10">
          <div class="card">
            <div class="card-header">
              NOMBRE D'ARTICLES COMMANDÉS

              <span class="float-right">
                <a class="cursor" title="Export excel(csv)"
                   (click)="exportSimpleExcelCsv(numberItemsOrderedPerPeriod, 'nombre-articles-commandes')">
                  <i class="fa fa-file-excel fa-2x space yoni-color"></i>
                </a>
              </span>
            </div>

            <div class="card-boby">
              <dx-chart id="chart-number-items-ordered"
                        (onPointClick)="displayDetailsNumberItemsOrderedByProvider($event)"
                        [dataSource]="numberItemsOrderedPerPeriod">
                <dxi-series
                  argumentField="numWeek"
                  valueField="Nombre d'articles"
                  name="Nombre d'articles commandés"
                  type="bar"
                  color="var(--cell-invoice-color)"
                >
                </dxi-series>
                <dxo-tooltip [enabled]="true"></dxo-tooltip>
                <dxo-export [enabled]="true"></dxo-export>
                <dxo-legend
                  verticalAlignment="bottom"
                  horizontalAlignment="center"
                  itemTextPosition="top">
                </dxo-legend>
              </dx-chart>
            </div>
          </div>
        </div>
      }

      @if(findNumberItemsOrderedPerProviderAndPeriodSelected) {
        <div class="col-md-6 mg-t-10">
          <div class="card">
            <div class="card-header">
              NOMBRE D'ARTICLES COMMANDÉS PAR FOURNISSEUR

              <span class="float-right">
                <a class="cursor" title="Export excel(csv)"
                   (click)="exportSimpleExcelCsv(findNumberItemsOrderedPerProviderAndPeriodSelected, 'nombre-articles-commandes-par-fournisseur')">
                  <i class="fa fa-file-excel fa-2x space yoni-color"></i>
                </a>
              </span>
            </div>

            <div class="card-boby">
              <dx-chart
                id="nb-items-per-order"
                [dataSource]="findNumberItemsOrderedPerProviderAndPeriodSelected"
                [rotated]="true"
                [barGroupWidth]="8"
                title="Nombre d'articles commandés par fournisseur">

                <dxo-common-series-settings argumentField="provider" type="stackedbar"></dxo-common-series-settings>

                <dxi-series valueField="Nombre d'articles" name="Nombre d'articles" color="var(--action-color)"></dxi-series>
                <dxo-export [enabled]="true"></dxo-export>
                <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltip"></dxo-tooltip>
                <dxo-legend verticalAlignment="bottom" horizontalAlignment="center">
                  <dxo-margin [left]="50"></dxo-margin>
                </dxo-legend>
              </dx-chart>
            </div>
          </div>
        </div>
      }

      @if(litigesNonConformite && seriesOptionsLitiges) {
        <div class="col-md-6 mg-t-10">
          <div class="card">
            <div class="card-header">
              LITIGES ET NON CONFORMITÉS

              <span class="float-right">
                <a class="cursor" title="Export excel(csv)"
                   (click)="exportSimpleExcelCsv(this.sortProperties(litigesNonConformite), 'nombre-litiges-motifs-non-conformes')">
                  <i class="fa fa-file-excel fa-2x space yoni-color"></i>
                </a>
              </span>
            </div>

            <div class="card-boby">
              <dx-chart id="chart-litiges-motifs" [dataSource]="litigesNonConformite" [series]="seriesOptionsLitiges">
                <dxo-tooltip [enabled]="true"></dxo-tooltip>
                <dxo-export [enabled]="true"></dxo-export>
                <dxo-legend
                  verticalAlignment="bottom"
                  horizontalAlignment="center"
                  itemTextPosition="top">
                </dxo-legend>
              </dx-chart>
            </div>
          </div>
        </div>
      }

      @if(egalimIndicator) {
        <div class="col-md-6 mg-t-10">
          <yo-indicateur-egalim
            [values]="[egalimIndicator.pourcentageDurable, egalimIndicator.pourcentageBio, egalimIndicator.pourcentageMontantProduitsPoissonViande]"
            [inputSeuils]="seuils"
            [isConformeEgalim]="egalimIndicator.egalim"
            [subtitle]="getPeriod() + '<br>' +getSubtitleSelectedUp()"
            [titleText]="customizeTextLabelGaugeEgalim"
            [tooltipText]="customizeTooltipGaugeEgalim"
            [legendText]="customizeTextGaugeEgalim"
            (onChangeSeuil)="changeSeuil($event)">
          </yo-indicateur-egalim>
        </div>
      }

      @if (topItemsByAmount) {
        <div class="col-md-6 mg-t-10">
          <div class="card">
            <div class="card-header">
              TOP ARTICLES COMMANDÉS PAR MONTANT

              <span class="float-right">
              <a class="cursor" title="Export excel(csv)"
                 (click)="exportSimpleExcelCsv(topItemsByAmount, 'top-3-articles-commandes-par-montant')">
                <i class="fa fa-file-excel fa-2x space yoni-color"></i>
              </a>
            </span>
            </div>

            <div class="card-boby">
              <dx-chart id="top-items-by-amount" [dataSource]="topItemsByAmount">
                <dxo-title text="Top 3 des articles commandés par montant"></dxo-title>
                <dxo-export [enabled]="true"></dxo-export>
                <dxi-series type="bar" name="Montant" argumentField="label" valueField="amount"></dxi-series>
                <dxo-common-annotation-settings type="custom" series="Montant" template="template" [allowDragging]="true">
                </dxo-common-annotation-settings>
                @for (data of topItemsByAmount; track data) {
                  <dxi-annotation
                    [data]="data"
                    [argument]="data.label"
                  >
                  </dxi-annotation>
                }
                <dxo-legend [visible]="false"></dxo-legend>
                <svg *dxTemplate="let annotation of 'template'" class="annotation">
                  <image attr.href="{{ getImageTrophyTop3Path(annotation, true) }}" width="60" height="40"/>
                  <rect x="0" y="0" class="border"/>
                  <text x="70" y="25" class="state">{{ annotation.argument }}</text>
                  <text x="0" y="60">
                    <tspan class="caption">Montant:</tspan>
                    <tspan class="capital" dx="5">{{ annotation.data.amount + ' €' }}</tspan>
                  </text>
                </svg>
              </dx-chart>
            </div>
          </div>
        </div>
      }

      @if(topItemsByWeight) {
        <div class="col-md-6 mg-t-10">
          <div class="card">
            <div class="card-header">
              TOP ARTICLES COMMANDÉS PAR VOLUME

              <span class="float-right">
                <a class="cursor" title="Export excel(csv)"
                   (click)="exportSimpleExcelCsv(topItemsByWeight, 'top-3-articles-commandes-par-volume')">
                  <i class="fa fa-file-excel fa-2x space yoni-color"></i>
                </a>
              </span>
            </div>

            <div class="card-boby">
              <dx-chart id="top-items-by-weight" [dataSource]="topItemsByWeight">
                <dxo-title text="Top 3 des articles commandés par volume"></dxo-title>
                <dxo-export [enabled]="true"></dxo-export>
                <dxi-series type="bar" color="var(--success-color)" name="Volume" argumentField="label"
                            valueField="quantity"></dxi-series>
                <dxo-common-annotation-settings type="custom" series="Volume" template="template" [allowDragging]="true">
                </dxo-common-annotation-settings>
                @for (data of topItemsByWeight; track data) {
                  <dxi-annotation
                    [data]="data"
                    [argument]="data.label"
                  >
                  </dxi-annotation>
                }
                <dxo-legend [visible]="false"></dxo-legend>
                <svg *dxTemplate="let annotation of 'template'" class="annotation">
                  <image attr.href="{{ getImageTrophyTop3Path(annotation, false) }}" width="60" height="40"/>
                  <rect x="0" y="0" class="border"/>
                  <text x="70" y="25" class="state">{{ annotation.argument }}</text>
                  <text x="0" y="60">
                    <tspan class="caption">Volume :</tspan>
                    <tspan class="capital" dx="5">{{ annotation.data.quantity + ' Kg' }}</tspan>
                  </text>
                </svg>
              </dx-chart>
            </div>
          </div>
        </div>
      }

      @if(volumeItemsByProvider) {
        <div class="col-md-6 mg-t-10">
          <div class="card">
            <div class="card-header">
              MONTANTS GLOBAL DES ACHATS PAR FOURNISSEUR SUR LA PERIODE

              <span class="float-right">
                <a class="cursor" title="Export excel(csv)"
                   (click)="exportSimpleExcelCsv(volumeItemsByProvider, 'montant-global-achats-par-fournisseur')">
                  <i class="fa fa-file-excel fa-2x space yoni-color"></i>
                </a>
              </span>
            </div>

            <div class="card-boby">
              <dx-chart id="chart-amount-items-by-period" [dataSource]="volumeItemsByProvider">
                <dxi-series
                  argumentField="provider"
                  valueField="amount"
                  name="Montants global des achats par fournisseur sur la période"
                  type="bar"
                  color="var(--egalim-siqo-color)"
                >
                </dxi-series>
                <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeToolTipAmountItems"></dxo-tooltip>
                <dxo-export [enabled]="true"></dxo-export>
                <dxo-legend
                  verticalAlignment="bottom"
                  horizontalAlignment="center"
                  itemTextPosition="top">
                </dxo-legend>
              </dx-chart>
            </div>
          </div>
        </div>
      }

      @if(weightsByAppellationPerPeriod || amountsByAppellationPerPeriod) {
        <div class="col-md-12 mg-t-10">
          <div class="card">
            <div class="card-header">
              DÉTAIL DES MONTANTS ET DU POIDS PAR APPELLATION SELECTIONNÉE
            </div>

            <div class="card-boby">

              @if(amountsByAppellationPerPeriod) {
                <span class="float-left">
                  <a class="cursor" title="Export excel(csv)"
                     (click)="exportSimpleExcelCsv(amountsByAppellationPerPeriod, 'montant-par-appellation')">
                    <i class="fa fa-file-excel fa-2x space yoni-color"></i>
                  </a>
                </span>
              }

              <div class="row">

                @if(amountsByAppellationPerPeriod) {
                  <div class="col-md-12">
                    <dx-pie-chart
                      id="amountsByAppellationPerPeriod"
                      title="Montants par appellation sélectionnée"
                      palette="bright"
                      [dataSource]="amountsByAppellationPerPeriod"
                    >
                      <dxo-legend
                        orientation="horizontal"
                        itemTextPosition="right"
                        horizontalAlignment="center"
                        verticalAlignment="bottom"
                        [columnCount]="4"
                      ></dxo-legend>
                      <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltipPieWithDevise"></dxo-tooltip>
                      <dxo-export [enabled]="true"></dxo-export>
                      <dxi-series argumentField="tooltip" valueField="amount">
                        <dxo-label
                          [visible]="true"
                          position="columns"
                          [customizeText]="customizeLabelPieWithDevise"
                        >
                          <dxo-font [size]="16"></dxo-font>
                          <dxo-connector [visible]="true" [width]="0.5"></dxo-connector>
                        </dxo-label>
                      </dxi-series>
                    </dx-pie-chart>
                  </div>
                }

              </div>
            </div>
          </div>
        </div>
      }

    </div>


  </div>

</div>
